module.exports = __webpack_public_path__ + "img/lotto-result-icon.156ab853.png";